/** Currencies accepted for order monetary values across Klareo apps. */
export const CURRENCIES = ['EUR', 'USD', 'GBP'] as const;

/** Type for accepted currency codes. */
export type Currency = (typeof CURRENCIES)[number];
